import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { closePopup } from '../../actions/uiActions';
import { deleteUser } from '../../actions/userActions';
import CloseIcon from '@mui/icons-material/Close';

class DeleteUser extends React.Component {

    handleDeleteUser = (event) => {
        event.preventDefault()
        this.props.deleteUser(this.props.popupInfo)

    }

    handleClick = (event) => {
        event.preventDefault()
        this.props.closePopup()
    }

    render() {
        let user = this.props.userList.find(x => x.id === this.props.popupInfo)
        return (<Dialog
            open={true}
            onClose={this.handleClick}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <CloseIcon onClick={this.handleClick} className="closePoup" />
            <DialogTitle id="alert-dialog-title" className="changepassdialog">
                {'Delete this User?'}
                {' '}
            </DialogTitle>
            <DialogContent>

                    <div className="passwordResetbox">
                        <h5 className="DeletepepsiText">{user.userName}</h5>
                        <button
                            className="btn"
                            onClick={this.handleDeleteUser}
                        >
                            Delete
                  </button>
                    </div>

            </DialogContent>
        </Dialog>
        )
    }
}

function mapStateToProps(state) {
    return {
        popupInfo: state.ui.popupInfo,
        userList: state.users.data,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators({ closePopup, deleteUser }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DeleteUser)
